import { useNuxtApp, useRoute, useHead, useAsyncData, useServerSeoMeta } from "#imports";
import { ref } from "vue";
import { appConfigStore } from "#sitis/stores/modules/app-store";
export default function useSitisCMSPage() {
  const { $api, ssrContext } = useNuxtApp();
  const { configList } = appConfigStore();
  const slug = useRoute().path.split("/").slice(-1).join();
  const cmsTitle = ref("");
  const cmsKeywords = ref("");
  const cmsDescription = ref("");
  const getCMSContent = async () => {
    const { data: cmsContent } = await useAsyncData(
      `cms-content-${slug}`,
      async () => await $api.cmsContentApi.getContentPage(slug),
      {
        transform: (cmsContent2) => cmsContent2.page
      }
    );
    if (cmsContent.value) {
      cmsTitle.value = cmsContent.value.titleTag || cmsContent.value.title;
      cmsDescription.value = cmsContent.value.description;
      cmsKeywords.value = cmsContent.value.keywords;
      setSEOTitles({});
    }
  };
  const setSEOTitles = ({ seoTitle, seoDescription, seoKeywords }) => {
    useHead({
      title: seoTitle || cmsTitle.value || "",
      titleTemplate: `%s ${configList?.suffixDivider || ""} ${configList?.suffixTitle || ""}`,
      meta: [
        { name: "description", content: seoDescription || cmsDescription.value || "" },
        { name: "keywords", content: seoKeywords || cmsKeywords.value || "" }
      ]
    });
    useServerSeoMeta({
      ogTitle: () => `${seoTitle || cmsTitle.value || ""}`,
      ogDescription: () => `${seoDescription || cmsDescription.value || ""}`,
      ogType: "website",
      ogLocale: "ru_RU",
      ogUrl: () => process.server ? ssrContext.event.node.req.headers.host : window.location.host,
      ogImage: () => `${configList?.logoFront || ""}`,
      ogSiteName: () => `${configList?.siteName || ""}`,
      twitterDescription: () => `${seoDescription || cmsDescription.value || ""}`,
      twitterImage: () => `${configList?.logoFront || ""}`,
      twitterTitle: () => `${seoTitle || cmsTitle.value || ""}`,
      twitterCard: "summary_large_image"
    });
  };
  return {
    cmsTitle,
    cmsKeywords,
    cmsDescription,
    getCMSContent,
    setSEOTitles
  };
}
